// monitoring/* 페이지 번역
const monitoring = {
  home: {
    title: '전사모니터링',
    loading: '데이터를 불러오는 중...',
    noFactories: '등록된 공장이 없습니다',
    registerFactoryHint: '시스템 관리 메뉴에서 공장을 먼저 등록해주세요',
    status: {
      total: '총 사출기',
      running: '가동중',
      idle: '대기',
      stopped: '정지',
    },
  },
  enterprise: {
    v2: {
      targetModal: {
        title: '공장별 일일 목표 생산량',
        hint: '공장마다 하루 목표 생산량(샷 수)을 입력하세요. 바꾸기 전까지 매일 적용되고, 전사 목표는 합계로 자동 계산됩니다. 비우면 그 공장 목표를 지웁니다.',
        factory: '공장',
        today: '오늘 실적',
        target: '일일 목표',
        placeholder: '미설정',
        unit: '개',
        total: '전사 목표 (합계)',
        saving: '저장 중...',
        invalid: '목표는 1 이상의 정수로 입력하세요',
        saveFailed: '저장하지 못했습니다. 잠시 후 다시 시도하세요',
        notDeployed: '서버에 공장별 목표 기능이 아직 배포되지 않았습니다',
        forbidden: '공장 수정 권한이 없습니다',
        noPermission: '공장 수정(factory.update) 권한이 있어야 목표를 바꿀 수 있습니다',
      },
      breadcrumbRoot: '전사',
      pageLabel: '통합 대시보드',
      refresh: '새로 고침',
      retry: '다시 시도',
      loading: '불러오는 중...',
      noData: '데이터가 없습니다',
      loadFailed: '대시보드 데이터를 불러오지 못했습니다',
      unitEa: '개',
      unitMachine: '대',
      estimated: '추정',
      level: {
        good: '정상',
        warn: '경고',
        bad: '위험',
      },
      kpi: {
        oee: '종합 OEE',
        availability: '가용성',
        performance: '성능',
        quality: '양품률',
        defectRate: '불량률',
        utilization: '설비 가동률',
        production: '일일 생산량',
        energy: '에너지',
        oeeSub: '목표 {target}% · {diff}%p',
        baseline: '기준 {v}',
        inRange: '정상 범위',
        defectSub: '불량 {n}개 · 기준 {v} 이하',
        defectEstimated: '100 − 양품률 (추정)',
        utilizationSub: '{r} / {n}대 가동',
        productionSub: '목표 대비 {p}%',
        noTarget: '목표 미설정',
        energySub: '전일 {p}%',
        today: '오늘',
      },
      chart: {
        productionTitle: '종합 생산량 · 가동률 추이',
        oeeTitle: 'OEE 구성 추이',
        days: '({n}일)',
        production: '생산량(EA)',
        rate: '가동률(%)',
        oee: 'OEE',
        availability: '가용성',
        performance: '성능',
        quality: '품질',
      },
      factory: {
        title: '공장별 현황',
        activeAlarms: '미처리 알람 {n}개',
        rate: '가동률',
        production: '생산량',
        equipment: '설비',
        running: '가동',
        stopped: '정지',
        collect: {
          ok: '수집 정상',
          partial: '일부 정지',
          lost: '수집 끊김',
          none: '설비 없음',
        },
      },
      alarm: {
        title: '전사',
        all: '전체 보기',
        critical: '긴급 Critical',
        warning: '주의 Warning',
        info: '정보 Info',
        empty: '최근 알람이 없습니다',
      },
      target: {
        factoryGoal: '{a} / {g}',
        factoryNoTarget: '목표 미설정',
        companyOnlyNote: '전사 단일 목표만 설정됨 — 톱니 버튼에서 공장별 목표를 지정하세요',
        title: '생산 목표 대비 달성 (오늘)',
        ratio: '종합 달성률',
        goal: '목표',
        actual: '실적',
        remaining: '남은 목표',
        eta: '예상 달성 시간',
        hm: '{h}시간 {m}분',
        m: '{m}분',
        done: '달성',
        factoryNote: '공장별 막대: 전사 목표 대비 그 공장 생산량 (공장별 목표 미설정)',
      },
    },
    reports: {
      daily: '일일보고',
      weekly: '주간보고',
      monthly: '월간보고',
    },
    oee: {
      targetSetting: '목표 생산량 설정',
    },
  },
  factory: {
    selectFactory: '공장 선택',
    loadingData: '데이터를 불러오는 중...',
    noFactories: '등록된 공장이 없습니다',
    registerFactoryHint: '시스템 관리 메뉴에서 공장을 먼저 등록해주세요',
    loadFailed: '데이터를 불러오는데 실패했습니다.',
    factoryListLoadFailed: '공장 목록을 불러오는데 실패했습니다.',
    retry: '다시 시도',
    refresh: '새로 고침',
    breadcrumbRoot: '전사',
    overview: 'OVERVIEW',
    kpi: {
      activeRatio: '가동설비',
      totalMachines: '설비 수',
      running: '가동',
      idle: '대기',
      stopped: '정지',
      pendingAlarms: '미처리 알람',
      oee: 'OEE',
      dailyProduction: '일일 생산량',
      machineUnit: '대',
      caseUnit: '건',
    },
    environment: {
      title: '환경',
      temperature: '온도',
      tempUnit: '도',
      humidity: '습도',
      energy: '에너지',
      noise: '소음',
    },
    line: {
      title: '라인별 현황',
      production: '생산량',
      alarms: '알림',
      caseUnit: '건',
      running: '가동',
      idle: '대기',
      stopped: '정지',
      empty: '라인 정보가 없습니다',
    },
    machine: {
      title: '설비별 현황',
      statusFilter: '상태 필터',
      lineFilter: '라인 필터',
      running: '가동',
      idle: '대기',
      stopped: '정지',
      moldNumber: '금형번호',
      shotCount: '샷카운트',
      cav: 'CAV', // 캐비티 수 — 현장 약어 그대로
      ct: 'C/T', // 사이클 타임 — 현장 약어 그대로
      alarmsTitle: '활성 알람 {n}건',
      loading: '설비 정보를 불러오는 중...',
      empty: '표시할 설비가 없습니다',
    },
    alarm: {
      title: '실시간 알람',
      all: '전체',
      critical: '위험',
      warning: '경고',
      noActiveAlarms: '진행중인 알람이 없습니다.',
    },
  },
  realtimeShot: {
    v2: {
      breadcrumbRoot: '전사',
      allFactories: '전체 공장',
      refresh: '새로 고침',
      factory: '공장',
      line: '라인',
      all: '전체',
      deviationOnly: '이탈만',
      summary: '총 {n}대 · 이탈 {d}대',
      deviationTip: '이탈(추정): 직전 샷 대비 ±5% 이상 바뀐 값 — 기준값 API 가 없어 화면에서 계산',
      prevShot: '직전 샷',
      noDeviation: '이탈한 설비가 없습니다',
      colEquipment: '사출기',
      colUpdate: '업데이트',
    },
    title: '실시간 샷 현황',
    subtitle: '사출기별 실시간 샷 현황',
    update: '업데이트',
    loading: '데이터를 불러오는 중...',
    loadFailed: '데이터를 불러오는데 실패했습니다.',
    retry: '다시 시도',
    noData: '데이터가 없습니다.',
    options: {
      highlight: '변경셀 강조',
      delta: '변화량 표시',
      sortByUpdate: '업데이트순 정렬',
    },
    columns: {
      equipmentName: '사출기명',
      craftId: '제품명',
      shotCount: '샷카운트',
      updateDateTime: '업데이트시간',
      cycleTime: '사이클타임',
      tmInjSpeed1: '사출속도',
      tmInjPress1: '사출압력',
      tmInjPosi1: '사출위치',
      tmHoldSpeed1: '보압속도',
      tmHoldPress1: '보압압력',
      tmChargePress1: '계량압력',
      tmChargePosi1: '계량위치',
      turnPosi: '사출종료위치',
      cushion: '쿠션량',
      tmTemp1Current: '온도1',
      tmTemp2Current: '온도2',
      tmTemp3Current: '온도3',
      tmTemp4Current: '온도4',
      tmTemp5Current: '온도5',
    },
  },
  alarmAnalysis: {
    title: '알람 상세 분석',
    machinePrefix: '사출기: {name}',
    alarmIdPrefix: '알람 ID: {id}',
    loading: '알람 데이터를 불러오는 중...',
    loadFailed: '알람 데이터를 불러오는데 실패했습니다.',
    loadFailedTitle: '데이터 로드 실패',
    retry: '다시 시도',
    info: {
      title: '알람 정보',
      alarmId: '알람 ID',
      machine: '사출기',
      occurredAt: '발생 시간',
      duration: '지속 시간',
      severity: '심각도',
      status: '상태',
    },
    message: {
      title: '알람 메시지',
      description: '알람 상세 정보를 표시할 API가 필요합니다.',
      note: '현재 페이지는 알람 ID와 사출기 정보를 URL 파라미터로 받을 수 있도록 준비되어 있습니다.',
    },
    cause: {
      title: '원인 분석',
      placeholder: '알람 원인 분석 정보가 여기에 표시됩니다.',
    },
    action: {
      title: '권장 조치',
      placeholder: '권장 조치 사항이 여기에 표시됩니다.',
    },
    apiNotice: {
      label: 'API 연동 필요:',
      description: '알람 상세 정보를 표시하려면 백엔드 API 엔드포인트가 필요합니다.',
      endpoint: '예상 엔드포인트:',
    },
  },
  machine: {
    breadcrumbRoot: '전사',
    breadcrumbMonitoring: '모니터링',
    selectMonitoringPage: '모니터링 화면 선택',
    refresh: '새로 고침',
    selectFactory: '공장 선택',
    factoryPage: '공장 사출 현황 보기',
    factoryMachineCount: '설비 {n}대',
    selectMachine: '설비 선택',
    loading: '로딩 중...',
    loadingData: '데이터를 불러오는 중...',
    noEquipment: '등록된 설비가 없습니다',
    registerEquipmentHint: '시스템 관리 메뉴에서 설비를 먼저 등록해주세요',
    tabs: {
      overviewNew: '개요',
      process: '공정',
      dashboard: '대시보드',
      quality: '품질 · 생산',
      dataLog: '데이터 · 로그',
    },
    tabPlaceholder: '{tab} 컨텐츠 영역 (추후 추가 예정)',
    chartLabel: {
      shotNumber: '샷 번호',
      tempC: '온도(°C)',
      pressureMpa: '압력(MPa)',
      powerKw: '전력(kW)',
      speedMms: '속도(mm/s)',
      positionMm: '위치(mm)',
    },
    legendName: {
      injectionPressure: '사출압력',
      holding: '보압',
      meteringPressure: '계량압력',
      backPressure: '배압',
      holdingPressure: '보압압력',
      injectionPressure2: '사출압력',
      cycleTime: '사이클타임',
      injectionTime: '사출시간',
      holdingTime: '보압시간',
      meteringTime: '계량시간',
      coolingTime: '냉각시간',
      pressureKw: '전력(kW)',
      speed: '속도',
      position: '위치',
      occurrence: '발생 횟수',
      cumulativeRatio: '누적 비율 (%)',
      alarmCount: '알람 수',
      ucl: 'UCL',
      cl: 'CL',
      lcl: 'LCL',
      measured: '측정값',
      rangeValue: '범위값',
      upper: '상한',
      lower: '하한',
      motorStatus: '모터 상태',
    },
    common: {
      noData: '데이터 없음',
      loading: '로딩 중...',
      dataLoadFailed: '데이터를 불러오는데 실패했습니다.',
      productionWidgetWip: '생산 위젯 준비 중',
      configError: '설정 오류',
      widgetContent: '위젯 내용',
      occurredPrefix: '발생: ',
      occurring: '발생중',
      resolved: '해결됨',
      alarmHistoryEmpty: '알람이력 없음',
    },
    widget: {
      titleSuffix: {
        temperature: '온도(°C)',
        pressure: '압력(MPa)',
        energy: '에너지(kW)',
      },
      modal: {
        title: '대시보드 위젯 추가',
        size1x1: '1×1 (기본)',
        size2x1: '2×1 (가로)',
        size1x2: '1×2 (세로)',
        size2x2: '2×2 (크게)',
        back: '뒤로 가기',
      },
      dashboardNew: {
        myDashboard: '내 대시보드',
        subtitle: '위젯 {n}개',
        autoRefresh: '자동 갱신 {v}',
        addEdit: '위젯 추가 · 편집',
        editMode: '편집 모드',
        editHint: '위젯을 끌어 배치 · 크기 배지를 눌러 크기 변경 · X로 제거',
        resetLayout: '레이아웃 초기화',
        resetConfirm: '배치된 위젯을 모두 제거할까요?',
        doneEdit: '편집 완료',
        addWidget: '위젯 추가',
        remove: '제거',
        sizeBadgeHint: '누르면 들어가는 다음 크기로 바뀝니다',
        searchPlaceholder: '위젯 검색 (온도, 압력, 알람…)',
        cat: { all: '전체', process: '공정', equipment: '설비정보', quality: '품질', alarm: '알람', user: '사용자' },
        catHint: '칩을 누르면 해당 카테고리만 표시',
        note: { process: '공정', equipment: '설비정보', quality: '품질', alarm: '알람', user: '사용자' },
        placed: '배치됨',
        add: '추가',
        placedCount: '배치된 위젯 {n} / {total}',
        close: '닫기',
        noResults: '검색 결과가 없습니다',
        sizeTitle: '위젯 크기 선택',
        sizeHint: '그리드 칸 수를 고르세요. 배치 후 크기 배지를 눌러 다시 바꿀 수 있습니다.',
        sizeDesc: { '1x1': '핵심 수치 1~2개', '2x1': '표·추이 차트에 적합 (추천)', '1x2': '목록·이력', '2x2': '복합 차트 · 상세' },
        addWithSize: '{size}로 추가',
        noFit: '이 크기로 넣을 빈 자리가 없습니다',
      },
      types: {
        temperature: { name: '온도', desc: 'Zone별 온도 현황 및 추이' },
        pressure: { name: '압력', desc: '사출/보압 압력 모니터링' },
        energy: { name: '에너지', desc: '전력 소비량 및 효율' },
        basicInfo: { name: '기본정보', desc: '제품명, 샷카운트, 사이클타임, 캐비티수' },
        alarmHistory: { name: '알람이력', desc: '최근 알람 발생 이력' },
        injectionInfo: { name: '기본사출정보', desc: '사출 설정값 및 파라미터' },
        custom: { name: '사용자 모듈', desc: '커스텀 위젯 추가' },
        cycle: { name: '사이클', desc: '사이클타임 평균·최소·최대와 최근 샷 추이' },
        spc: { name: 'SPC', desc: 'X-bar 관리도 · UCL/LCL 이탈 감지' },
        quality: { name: '양/불', desc: '오늘 양품률 · 양품 · 불량 수' },
      },
      body: {
        loading: '불러오는 중...',
        loadFailed: '불러오지 못했습니다',
        noData: '데이터 없음',
        warning: '주의',
        set: '설정',
        latestShot: '최근 샷',
        avgPower: '최근 {n}샷 평균',
        power: '전력',
        today: '오늘',
        sampleNote: '최근 {n}샷',
        efficiency: '효율',
        shot: '샷',
        legendInjection: '사출',
        legendHolding: '보압',
        avg: '평균',
        min: '최소',
        max: '최대',
        cycleTime: '사이클타임',
        measured: '측정값',
        out: '이탈',
        spcNote: 'X-bar 관리도 · {p}',
        goodRate: '양품률',
        good: '양품',
        defect: '불량',
        defectRate: '불량률',
      },
      builder: {
        title: '사용자 모듈 만들기',
        widgetSize: '위젯 크기',
        widgetTitle: '위젯 제목',
        widgetTitlePlaceholder: '위젯 제목 입력',
        chartType: '차트 타입',
        chartLine: '라인 차트',
        chartBar: '바 차트',
        chartArea: '영역 차트',
        xAxis: 'X축 데이터',
        yAxis: 'Y축 데이터',
        xShotNumber: '샷 번호',
        xTime: '시간',
        yPressure: '압력 (MPa)',
        yTemperature: '온도 (℃)',
        ySpeed: '속도 (mm/s)',
        yPosition: '위치 (mm)',
        preview: '미리보기',
        summary: '설정 요약',
        summarySize: '크기',
        summaryTitle: '제목',
        summaryTitleEmpty: '(미입력)',
        summaryChart: '차트 타입',
        summaryX: 'X축',
        summaryY: 'Y축',
        cancel: '취소',
        complete: '완료',
      },
    },
    overview: {
      basicInfo: '기본정보',
      injection: '사출',
      holding: '보압',
      metering: '계량',
      mold: '금형',
      ejector: '이젝터',
      heater: '히터온도',
      noData: '데이터가 없습니다',
      labels: {
        productName: '제품명',
        shotCount: '샷카운트',
        cycleTime: '사이클타임',
        cavityCount: '캐비티수',
        unitCount: '회',
        unitPiece: '개',
        maxPressure: '최대사출압력',
        startPosition: '사출시작위치',
        switchPosition: '사출전환위치',
        injectionTime: '사출시간',
        injectionSpeed: '사출속도',
        suckbackTime: '석백시간',
        suckbackSpeed: '석백속도',
        switchMode: '보압전환모드',
        switchInput: '보압전환입력',
        pressure1: '보압1단계압력',
        pressure2: '보압2단계압력',
        time1: '보압1단계시간',
        time2: '보압2단계시간',
        meteringPosition: '계량위치',
        meteringSpeed: '계량속도',
        meteringPressure: '계량압력',
        meteringTime: '계량시간',
        moldThickness: '금형두께',
        openPosition: '형개위치',
        closePosition: '형폐위치',
        openTime: '형개시간',
        closeTime: '형폐시간',
        moldTemp1: '금형온도1',
        moldTemp2: '금형온도2',
        forwardPosition: '전진위치',
        backwardPosition: '후퇴위치',
        forwardSpeed: '전진속도',
        backwardSpeed: '후퇴속도',
        zoneTemp: '존{n}온도',
        nozzleTemp: '노즐온도',
      },
    },
    spc: {
      measurementItem: '측정 항목',
      params: {
        cycleTime: '사이클타임',
        injectionPressure: '사출압력',
        injectionSpeed: '사출속도',
        moldTemperature: '금형온도',
        cushion: '쿠션량',
      },
      loading: 'SPC 데이터를 불러오는 중...',
      xbarChart: 'X̄ 관리도 (X-bar Chart)',
      rChart: 'R 관리도 (R Chart)',
      stats: '통계 정보',
      processCapability: '공정능력지수',
      basicStats: '기초통계',
      defectRate: '불량률',
      sampleCount: '샘플 수',
      mean: '평균',
      stdDev: '표준편차',
      min: '최소값',
      max: '최대값',
      range: '범위',
      anomalyDetection: '이상점 검출',
      anomalyTime: '시간',
      anomalyValue: '값',
      anomalyType: '타입',
      noAnomaly: '이상점이 검출되지 않았습니다',
    },
    passFail: {
      back: '뒤로가기',
    },
    inspectionPhotos: {
      subTabSpc: '공정관리 (SPC)',
      subTabJudge: '공정검사',
      subTabProduction: '생산',
      subTabPhotos: '비전검사',
      subTabFusion: '융합검사',
      subTabSync: '샷동기화',
      comingSoon: '준비 중',
      period: '기간',
      good: '양품',
      none: '미판정',
      warn: '주의',
      bad: '불량',
      upload: '사진 업로드',
      uploadNotice: '업로드한 사진은 이 화면에서만 미리보기로 유지됩니다 (서버 저장 미연동)',
      front: '정면',
      topView: '상단',
      side: '측면',
      photoPlaceholder: '검수 사진',
      empty: '표시할 샷이 없습니다',
      prev: '이전',
      next: '다음',
    },
    visionInspection: {
      kpi: {
        inspected: '비전 검사',
        ok: '양품',
        ng: '불량',
        ngRate: '불량률',
        uninspected: '미검사 샷',
      },
      typeDistribution: '불량 유형별 현황',
      ngTotal: '불량 {n}건',
      typeFilterHint: '클릭하면 이 유형만 봅니다',
      types: {
        FLASH: '플래시(버)',
        WELDLINE: '웰드라인',
        SHORT: '미성형',
        SINK: '수축(싱크)',
        UNKNOWN: '기타',
      },
      date: '날짜',
      verdict: '판정',
      defectType: '유형',
      verdicts: {
        all: '전체',
        ok: '양품',
        ng: '불량',
      },
      resultCount: '{n}건',
      empty: '이 날짜에 비전 검사 결과가 없습니다',
      emptyFiltered: '조건에 맞는 검사 결과가 없습니다',
      noImage: '이미지 없음',
      detailTitle: '비전 검사 상세 · Shot #{n}',
      close: '닫기',
      unjudged: '미판정',
      field: {
        verdict: '비전 판정',
        defectType: '불량 유형',
        shotTime: '샷 시각',
        mold: '금형',
        processResult: '공정검사 결과',
        imageFile: '이미지 파일',
        shotUuid: '샷 UUID',
        sync: '샷동기화',
      },
      processNote: '공정검사 결과는 같은 샷의 공정 AI 판정으로, 참고용입니다. 두 결과를 합친 최종 판정은 융합검사에서 봅니다.',
      prev: '이전',
      next: '다음',
    },
    shotSync: {
      source: { label: '데이터 출처', processDemo: '공정: 데모 생성', processReal: '공정: 실수집', imageDemo: '이미지: 데모 카메라', imageReal: '이미지: IV4 실제', verdictDemo: '판정: 데모', liveLast: '현장 IV4 마지막 수신 {t} ({ago})', liveNone: '현장 IV4 수신 기록 없음', liveHint: '데모 카메라 모드에서도 현장 IV4 이미지는 계속 수집됩니다. 수신이 이어지면 IV4 모드로 전환할 수 있습니다' },
      ago: { min: '{n}분 전', hour: '{n}시간 전' },
      engine: { on: '동기화 엔진 동작 중', off: '동기화 엔진 꺼짐', lastRun: '마지막 실행 {t}' },
      mode: { TIME_WINDOW: '시간창 방식', SEQUENCE: '순번 방식' },
      kpi: { images: '확정 이미지', pairRate: '짝 지은 비율', confidence: '평균 신뢰도', unmatched: '짝 없음', clock: '카메라 시계 보정', lag: '샷→촬영 지연' },
      kpiHint: { clock: '카메라 시계가 서버보다 늦은 시간. 엔진이 매 실행 자동으로 추정해 이미지 시각을 보정합니다', lag: '사출 후 제품이 촬영되기까지 걸리는 시간. 엔진이 근거가 충분할 때만 갱신합니다' },
      unit: { sec: '{v}초' },
      timeline: { title: '실시간 동기화 (최근 3분)', sub: '지연 L {lag}초 · 허용 오차 ±{tol}초', shots: '공정 샷', images: '이미지', pending: '확정 대기', empty: '최근 3분 데이터가 없습니다', off: '스테이션이 꺼져 있어 실시간 동기화가 멈춰 있습니다' },
      legend: { shot: '짝 있는 샷', shotEmpty: '짝 없는 샷', match: '일치', check: '확인 필요', none: '짝 없음', pending: '확정 대기', window: '허용 창 (샷 + L ± τ)' },
      trend: { title: '10분 추이 (최근 3시간)', sub: '확정 이미지 · 상태별', empty: '추이 데이터가 없습니다', lagRange: '지연 L {v}초', clockRange: '시계 보정 {v}초' },
      date: '날짜', status: '상태',
      filters: { all: '전체', match: '일치', check: '확인 필요', unmatched: '짝 없음' },
      statuses: { MATCH: '일치', CHECK: '확인 필요', MISMATCH: '불일치', IMAGE_ONLY: '이미지만', SHOT_ONLY: '샷만', PENDING: '확정 대기' },
      reasonsLabel: '짝 없음 사유:',
      reasons: { DUPLICATE: '연속 촬영', OUT_OF_WINDOW: '허용 창 밖', NO_SHOT: '설비 정지 중', SHOT_TAKEN: '샷에 이미 짝 있음', LOW_CONFIDENCE: '낮은 신뢰도', NO_IMAGE: '촬영 누락' },
      resultCount: '{n}건',
      empty: '선택한 조건의 결과가 없습니다',
      col: { status: '상태', shot: '샷', shotTime: '샷 시각', image: '이미지', captured: '카메라 시각 → 보정', residual: '잔차', confidence: '신뢰도', verdict: '판정' },
      verdicts: { ok: '양품', ng: '불량' },
      demoTag: '데모',
      prev: '이전', next: '다음', close: '닫기',
      note: '잔차 = 보정된 촬영 시각 − (샷 시각 + 지연 L). 0에 가까울수록 잘 맞습니다. 일치·확인 필요 짝만 비전검사·융합검사에 쓰이고, 짝 없는 이미지는 사유와 함께 따로 남깁니다.',
      detail: { titleShot: '샷 #{n} 동기화 상세', titleImage: '짝 없는 이미지', reason: '사유', captured: '카메라 시각 (파일명)', saved: '비전 PC 저장 시각', note: '카메라(IV4) 시계는 서버보다 약 3분 늦습니다. 엔진은 비전 PC 저장 시각과 파일명 시각의 차이로 이를 자동 보정한 뒤 샷과 짝짓습니다.' },
      noStation: { title: '이 설비에는 비전 카메라 스테이션이 없습니다', desc: '카메라를 설치하고 동기화 스테이션을 등록하면, 엔진이 공정 샷과 이미지를 자동으로 짝지어 비전검사·융합검사에 연결합니다.', shots: '오늘 공정 샷 {n}개' },
      sourceNote: '데이터 출처 — {items}',
      sourceItems: { process: '공정 데모 생성', camera: '데모 카메라 이미지', verdict: '데모 판정' },
    },
    fusionInspection: {
      formulaTitle: '융합 판정식',
      formulaRule: 'α + β = 1, S_fusion ≥ θ 이면 불량',
      legendVision: 'S_vision · 비전 불량 확률 (0~1)',
      legendProcess: 'S_process · 공정 이상 점수 (0~1)',
      legendWeights: 'α·β·θ · 불량 유형별 가중치 (오른쪽 표)',
      weightsTitle: '유형별 가중치 테이블',
      planWeights: '계획서 초기값',
      planWeightsNote: '현재 가중치는 사업계획서에 정한 초기값입니다. 검증된 불량 라벨이 200건 이상 모이면 유형별로 α를 0.05 간격으로 탐색해 F1이 가장 높은 값으로 갱신합니다.',
      noWeights: '가중치 정보가 없습니다',
      colType: '유형',
      colSplit: '비전 : 공정',
      vision: '비전',
      process: '공정',
      fusion: '융합',
      kpi: {
        decided: '융합 판정 샷',
        processRate: '공정검사 불량률',
        visionRate: '비전검사 불량률',
        fusionRate: '융합 최종 불량률',
        rescued: '모호 샘플 포착',
        suppressed: '공정 단독 경보 정리',
      },
      kpiHint: {
        rescued: '비전 단독으로는 양품이었지만 공정 이상이 겹쳐 융합이 불량으로 잡은 샷 (클릭하면 목록 필터)',
        suppressed: '공정만 이상이고 이미지는 깨끗해 융합이 양품으로 정리한 샷 (클릭하면 목록 필터)',
      },
      countN: '{n}건',
      matrixTitle: '공정 × 비전 판정 일치표',
      matrixSub: '칸을 누르면 목록이 걸러집니다',
      visionOk: '비전 양품',
      visionNg: '비전 불량',
      processOk: '공정 양품',
      processNg: '공정 불량',
      fusedNg: '융합 불량 {n}',
      finalTypeTitle: '융합 불량 유형',
      processTypeNote: '공정 기인 = 이미지에서는 유형이 보이지 않았지만 공정 이상으로 융합이 불량 판정한 샷',
      date: '날짜',
      finalVerdict: '최종 판정',
      all: '전체',
      ok: '양품',
      ng: '불량',
      caseLabel: '조합',
      cases: {
        all: '전체',
        disagree: '두 검사 불일치',
        changed: '융합이 바꾼 판정',
        rescued: '모호 샘플 포착',
        suppressed: '공정 단독 경보 정리',
      },
      cells: {
        POK_VOK: '공정 양품 · 비전 양품',
        POK_VNG: '공정 양품 · 비전 불량',
        PNG_VOK: '공정 불량 · 비전 양품',
        PNG_VNG: '공정 불량 · 비전 불량',
      },
      empty: '이 날짜에 융합 판정 결과가 없습니다. 공정검사와 비전검사 결과가 모두 있는 샷만 판정합니다.',
      emptyFiltered: '조건에 맞는 판정 결과가 없습니다',
      colTime: '시각',
      colShot: '샷',
      colWeight: 'α / β',
      colFusion: '융합 점수 (│=θ)',
      colCase: '판정 조합',
      decisionCase: {
        BOTH_NG: '둘 다 불량',
        BOTH_OK: '둘 다 양품',
        BOTH_OK_FUSED_NG: '둘 다 양품 → 융합 불량',
        VISION_ONLY_NG_FUSED_NG: '비전만 불량 → 불량',
        VISION_ONLY_NG_FUSED_OK: '비전만 불량 → 양품',
        PROCESS_ONLY_NG_FUSED_NG: '공정만 불량 → 불량',
        PROCESS_ONLY_NG_FUSED_OK: '공정만 불량 → 양품',
        NONE: '—',
      },
      verdictScoreNote: '{n}건은 비전 모델 점수가 없어 비전 판정값에서 점수를 정했습니다 (불량 0.85, 양품 0.10).',
      detailTitle: '융합 판정 상세 · Shot #{n}',
      close: '닫기',
      noImage: '이미지 없음',
      calcTitle: '계산',
      appliedWeight: '적용 가중치: {type}',
      margin: '판정 여유도',
      decisionCaseLabel: '판정 조합',
      finalType: '최종 불량 유형',
      shotTime: '샷 시각',
      mold: '금형',
      scoreSource: '비전 점수 출처',
      source: {
        model: '비전 모델 확률',
        verdict: '비전 판정값에서 유도',
      },
      weightVersion: '가중치 버전',
      types: {
        FLASH: '플래시(버)',
        WELDLINE: '웰드라인',
        SHORT: '미성형',
        SINK: '수축(싱크)',
        PROCESS: '공정 기인',
        DEFAULT: '기본(유형 미상)',
      },
      prev: '이전',
      next: '다음',
    },
    shotJudge: {
      injectionInfo: '사출정보',
      drawingCaption: '제품 도면 · {id}',
      noImage: '도면 이미지 없음',
      productNumber: '제품번호',
      productName: '제품명',
      settingsTitle: '셋팅값',
      settingsBadge: '비교 기준 · 읽기 전용',
      settingsNote: '설정값은 청색 · 원본은 공정 탭 > 설정값 (단일 출처)',
      settingsEstimatedNote: '쿠션량은 설정 항목이 없어 최근 10샷 평균(추정)을 기준으로 씁니다',
      estimated: '추정',
      shotHistory: 'Shot History',
      recentN: '최근 {n}샷',
      defectOnly: '불량만 보기',
      colShot: 'Shot',
      colMetering: '계량',
      colInjection: '사출',
      colHeater: '히터',
      colSpeed: '속도',
      colCushion: '쿠션',
      colTime: '시간',
      colJudge: '판정',
      good: '양품',
      bad: '불량',
      warn: '주의',
      none: '미판정',
      tableNote: '규격 이탈 셀만 적색 — 행 전체를 칠하지 않습니다 · 행 클릭 → 우측 비교 차트 갱신 · 이탈 기준: 불러온 샷의 평균 ±3σ (추정)',
      loading: '샷 이력을 불러오는 중...',
      loadFailed: '샷 이력을 불러오지 못했습니다',
      empty: '표시할 샷이 없습니다',
      compareTitle: '설정값 vs 실측값 비교',
      shotBadge: 'Shot #{n} · {j}',
      settingLegend: '설정값',
      measuredLegend: '실측값',
      axisMetering: '계량 위치',
      axisInjection: '사출 위치',
      axisHeater: '히터 온도',
      axisSpeed: '사출 속도',
      axisCushion: '쿠션량',
      axisTime: '사출 시간',
      outOfSpec: '{axes} 축이 규격을 벗어났습니다',
      inSpec: '모든 축이 규격 안에 있습니다',
      noSelection: '샷 이력에서 샷을 선택하세요',
      lstmButton: 'LSTM 불량 원인 분석',
      measuredTitle: '선택 샷 실측값 — #{n}',
      judgeLabel: '판정',
      mMetering: '계량위치',
      mInjection: '사출위치',
      mHeater: '히터온도',
      mSpeed: '사출속도',
      mCushion: '쿠션량',
      mTime: '사출시간',
      lstmTitle: 'LSTM 불량 원인 분석 - 인라인 (핵심 3종)',
      lstmImportance: '1. 불량 원인 인자 중요도',
      lstmDominant: '이번 불량은 {f}의 영향이 지배적 ({p}%)',
      lstmRecommend: '2. 공정 튜닝 추천값',
      lstmDetail: 'AI 분석 자세히 보기',
      colParam: '파라미터',
      colCurrent: '현재',
      colRecommended: '추천',
      lstmConfidence: '3. 모델 예측 신뢰도',
      confidence: '신뢰도',
      confidenceNote: '이 분석을 신뢰해도 되는 수준 - {p}% ({lv})',
      levelHigh: '높음',
      levelMid: '보통',
      levelLow: '낮음',
      lstmLoading: 'LSTM 분석 결과를 불러오는 중...',
      lstmFailed: 'LSTM 분석 결과를 불러오지 못했습니다 (AI 서비스 응답 없음)',
      lstmNoCraft: '제품 ID가 없어 LSTM 분석을 실행할 수 없습니다',
      lstmNoData: '분석 데이터가 없습니다',
      close: '닫기',
    },
    production: {
      trendTitle: '생산량 추이 (최근 14일)',
      avgLine: '14일 평균',
      trendNote: '설비별 목표치가 없어 생산이 있었던 날의 평균(추정)을 기준선으로 씁니다 · 막대 위 숫자는 평균 대비 차이 · 생산량 = 샷 수',
      sampleNote: '일별 집계 API 미배포 — 최근 {n}샷을 날짜별로 묶은 값(추정) · 기준선은 생산이 있었던 날의 평균',
      todayTitle: '오늘 실적',
      qualityTitle: '양품 / 불량',
      production: '생산량',
      targetRatio: '목표 대비',
      pph: 'PPH',
      utilization: '가동률',
      goodRate: '양품률',
      defect: '불량',
      unitShot: 'shot',
      unitShotPerHour: 'shot/h',
      estimated: '추정',
      noTarget: '설비별 일일 목표치가 설정되어 있지 않습니다',
      loading: '생산 데이터를 불러오는 중...',
      loadFailed: '생산 데이터를 불러오지 못했습니다',
      empty: '최근 14일 샷 이력이 없습니다',
      kpiNote: '생산량·양품률·불량은 오늘 샷 이력 기준(양품률은 판정된 샷 기준) · PPH 는 생산이 있었던 시간대의 평균(추정) · 가동률은 설비 카드의 24시간 타임라인 기준 · 목표 대비는 설비별 목표치가 없어 —',
    },
    overviewNew: {
      realtime: '실시간 동작 현황',
      estimated: '추정',
      estimateHint: '백엔드에 공정 단계 신호가 없어 마지막 샷 수신 시각과 설정 시간으로 단계를 추정합니다',
      statusRunning: '가동중',
      statusIdle: '대기',
      statusStopped: '정지',
      injectionShort: '사출',
      modelLabel: '형폐, 사출, 보압, 냉각, 형개 순서의 사출기 동작 모델',
      modelLoading: '모델을 불러오는 중...',
      currentValues: '현재 단계 수치',
      injSpeed: '사출속도',
      injPressure: '사출 압력',
      screwPosition: '스크류 위치',
      injTime: '사출 시간',
      nozzleTemp: '노즐 온도',
      barrelTemp: '배럴 온도',
      cctv: 'CCTV 실시간',
      cctvPlaceholder: '카메라 라이브',
      cctvNotConnected: '카메라 미연동',
      kpiUtilization: '가동률',
      kpiShotCount: '샷카운트',
      kpiDefectRate: '불량률',
      kpiCycleTime: '사이클타임',
      tempSummary: '온도 요약',
      tempLink: '공정 - 요약 바로가기',
      avgTemp: '평균 온도',
      maxDeviation: '최대 편차',
      warningZones: '경고 Zone 수',
      oilTemp: '오일 온도',
      normal: '정상',
      warning: '경고',
      zoneUnit: '개',
      recentAlarms: '최근 알람',
      allAlarms: '전체',
      noAlarms: '최근 알람이 없습니다',
      qualitySummary: '품질 · 생산 요약',
      qualityLink: '품질 · 생산',
      goodRate: '양품률',
      good: '양품',
      defect: '불량',
      unjudged: '미판정',
      cpk: '공정능력 CPK',
      kpiDailyProduction: '일일 생산량',
      dailyProduction: '일일생산',
      dailyUnavailable: '오늘 집계 API 응답이 없어 표시할 수 없습니다',
      loading: '데이터를 불러오는 중...',
      loadFailed: '데이터를 불러오는데 실패했습니다.',
    },
    dataLog: {
      subTab: { shots: '샷로그', drive: '구동부 작동이력', alarms: '알람 이력', analysis: '알람 분석' },
      filter: '필터',
      reset: '초기화',
      unitNote: '단위: 시간 s, 위치·쿠션량 mm (열 머리글에 마우스를 올리면 표시)',
      factory: '공장',
      machine: '설비',
      product: '제품명(금형)',
      period: '기간',
      shotRange: '샷 범위',
      columnsPick: '열 선택',
      severityNotInDrive: '구동부 이력에는 심각도 정보가 없습니다',
      limit: '표시 개수',
      limitOption: '{n}개',
      startShot: '샷 범위 (시작 번호)',
      startShotPlaceholder: '전체',
      sampleInterval: '샘플 간격',
      intervalOption: '{n}샷마다',
      columns: '표시 열',
      shotsTitle: '샷 로그',
      totalCount: '총 {n}건',
      outCount: '이탈 {n}건',
      estimated: '추정',
      onlyOut: '이탈만',
      no: 'No.',
      shotTime: '샷 시각',
      outNote: '이탈 = 불러온 샷의 열별 평균 ±{k}σ 를 벗어난 값 (한계값이 설정되어 있지 않아 화면에서 추정)',
      driveTitle: '구동부별 작동기록',
      driveType: '구동부',
      time: '시간',
      action: '동작',
      pressure: '압력',
      speed: '속도',
      position: '위치',
      searchPlaceholder: '검색어를 입력해주세요.',
      all: '전체',
      alarmsTitle: '알람 발생 기록',
      severity: '심각도',
      critical: '불량',
      warning: '주의',
      info: '정보',
      occurredAt: '발생 시간',
      code: '코드',
      message: '설명',
      settingValue: '설정값',
      actualValue: '실행값',
      status: '상태',
      statusActive: '진행중',
      statusResolved: '해결',
      paretoTitle: '알람 파레토 분석',
      paretoNote: '코드별 발생 건수 + 누적 비율',
      errorCode: '에러',
      timelineTitle: '알람 발생 타임라인',
      timelineNote: '시간대별 발생 수',
      baseline80: '80% 기준선',
      count: '발생 건수',
      cumulative: '누적 비율',
      loading: '데이터를 불러오는 중...',
      loadFailed: '데이터를 불러오는데 실패했습니다.',
      noData: '데이터가 없습니다',
    },
    spcNew: {
      monitoring: '{p} 모니터링',
      parameter: '측정 항목',
      loading: 'SPC 데이터를 불러오는 중...',
      spcUnavailable: '이 설비·항목의 SPC 설정이 없어 관리도를 계산할 수 없습니다',
      noChart: '관리도를 그릴 샷이 부족합니다',
      chartNote: '부분군 평균(X̄) 관리도 · 시각은 각 부분군의 최신 샷 시각',
      rChartNote: '부분군 범위(최대−최소) 관리도 · 시각은 X̄ 관리도와 같은 부분군 기준',
      moldTempNoData: '금형온도는 수집 데이터가 없어 관리도를 계산할 수 없습니다',
      noData: '데이터 없음',
      pp: 'PP',
      ppk: 'PPK',
      anomalyCount: '최근 {n}건',
      outOfControl: '이탈',
      capabilityTitle: '공정 능력지수',
      cp: 'CP',
      cpk: 'CPK',
      defectRate: '부적합률',
      subgroupSize: '부분군 크기',
      productionTitle: '생산 요약',
      production: '생산량',
      goodRate: '양품률',
      pph: 'PPH',
      defects: '불량',
      estimated: '추정',
      unitShot: 'shot',
      unitShotPerHour: 'shot/h',
      productionNote: '{d} 샷 이력 기준 · 양품률은 판정된 샷(양품+불량) 기준 · PPH 는 생산이 있었던 시간대의 평균(추정)',
      loadFailed: '데이터를 불러오는데 실패했습니다.',
    },
    processNew: {
      subTab: { cycle: '사이클', temperature: '온도', drive: '구동', monitor: '감시', setup: '설정값' },
      autoScale: '자동 스케일',
      dataHold: '데이터홀드',
      chart: '차트',
      chartAll: '전체',
      loading: '데이터를 불러오는 중...',
      loadFailed: '데이터를 불러오는데 실패했습니다.',
      noData: '데이터가 없습니다',
      noProfile: '프로파일 데이터가 없습니다',
      noTrend: '트렌드 데이터가 없습니다',
      estimated: '추정',
      step: '진행',
      shotNo: '샷',
      average: '평균',
      overlay: '{a}/{b} 오버레이',
      singleShot: '샷 {a}',
      injectionProfile: '사출 프로파일',
      cycleTrend: '사이클 타임 트렌드',
      holdingProfile: '보압 프로파일',
      meteringProfile: '계량 프로파일',
      cycleStats: '사이클 통계',
      statAvg: '평균 사이클',
      statMin: '최소',
      statMax: '최대',
      statStd: '표준편차',
      statLatest: '최근',
      legendSpeed: '속도',
      legendPressure: '압력',
      legendShot: 'SHOT',
      legendMetering: '계량',
      legendCooling: '냉각',
      legendHolding: '보압',
      legendInjection: '사출',
      legendCycle: '사이클',
      legendHoldingPressure: '보압',
      legendTime: '시간',
      legendBackPressure: '배압',
      legendCushion: '쿠션위치',
      legendMeteringPressure: '계량압',
      legendInjectionPressure: '사출압',
      legendUpper: '상한',
      legendLower: '하한',
      statusNormal: '정상',
      statusError: '오류',
      statusRunning: '정상',
      statusIdle: '대기',
      statusStopped: '정지',
      setTemp: '설정',
      deviation: '편차',
      tempTrend: '온도 트렌드',
      deviationStatus: '온도 편차 현황',
      deviationTolerance: 'Zone별 편차 (허용 ±{n}℃)',
      deviationFromAvg: '전체 Zone 평균 기준 ± 편차 (허용 ±{n}℃)',
      diffFromAvg: '평균 대비',
      avgLine: '평균 {v}℃',
      tempStats: '온도 통계',
      avgTemp: '평균 온도',
      maxDeviation: '최대 편차',
      maxTemp: '최대',
      driveInjection: '사출 구동부',
      driveMetering: '계량 구동부',
      driveHolding: '보압 구동부',
      pressure: '압력',
      speed: '속도',
      position: '위치',
      elapsed: '작동 시간',
      pressureTrend: '압력 트렌드',
      motorStatus: '모터 상태',
      backPressureMonitor: '보압 모니터링',
      axisPressureShot: '압력 / 샷번호',
      axisStatusShot: '상태 / 샷 번호',
      axisBackPressureShot: '배압 / 샷 번호',
      moldEjectorSettings: '금형 · 이젝터 설정값',
      moldOpenPos: '형개위치',
      moldClosePos: '형폐위치',
      moldOpenTime: '형개시간',
      moldCloseTime: '형폐시간',
      ejectorForward: '이젝터 전진',
      ejectorBackward: '이젝터 후퇴',
      watchAutoWatch: '자동감시',
      watchUse: '사용',
      watchNotUse: '미사용',
      watchReference: '참고값',
      watchRefAuto: '자동샘플링',
      watchRefUser: '사용자설정',
      watchNote: '참고값 = 최근 {n}샷 평균, 상/하한 = ±{k}σ (추정)',
      watchLegendOut: '상/하한 초과',
      watchLegendImportant: '중요 감시 지정',
      watchTable1: '감시표 1 - 구동 파라미터 (sec/mm)',
      watchTable2: '감시표 2 - 사출 · 보압 파라미터',
      watchRowGroup: '구분',
      watchRowActual: '실제값',
      watchRowDeviation: '편차량',
      watchRowReference: '참고값',
      watchRowUpper: '상한',
      watchRowLower: '하한',
      watchRowSelect: '선택',
      setupCount: '{n}종',
      setupHistoryButton: '변경 이력 보기',
      setupHistoryUnavailable: '설정 변경 이력 API 가 아직 없습니다',
      setupHistoryLess: '최근 20건만 보기',
      setupAddWidget: '대시보드 위젯으로 추가',
      setupWidgetNoSlot: '대시보드에 빈 슬롯이 없습니다',
      setupHistoryTitle: '최근 설정 변경 이력',
      setupHistoryTime: '변경 시각',
      setupHistoryItem: '항목',
      setupHistoryBefore: '변경 전',
      setupHistoryAfter: '변경 후',
      setupHistoryUser: '변경자',
      setupHistoryEmpty: '최근 설정 변경 이력이 없습니다',
    },
  },
  equipmentBoard: {
    selectMachine: '사출기 선택',
    loading: '불러오는 중...',
    update: '업데이트',
    empty: '사출기를 선택하세요',
    alarmHistory: '알람 이력',
    alarmEmpty: '알람 이력이 없습니다',
    occurredPrefix: '발생 ',
    statusActive: '발생중',
    statusResolved: '해제됨',
    shotData: '샷 데이터',
    shotCountSuffix: '{n}건',
    noData: '데이터가 없습니다',
    panelAlarm: '알람 발생',
    remainingSuffix: '외 {n}건',
    confirm: '확인',
    confirmWithRemaining: '확인 (외 {n}건)',
    cols: {
      shotTime: '샷시간',
      craftId: '제품명',
      shotCount: '샷카운트',
      cycleTime: '사이클타임',
      injTime: '사출시간',
      holdTime: '보압시간',
      chargeTime: '계량시간',
      moldOpenTime: '형개시간',
      moldCloseTime: '형폐시간',
      fetchTime: '취출시간',
      ejectTime: '이젝터시간',
    },
  },
  machineDataView: {
    title: '사출기 데이터 조회',
    loading: '불러오는 중...',
    loadingDataInit: '데이터를 불러오는 중입니다...',
    loadingProgressInit: '전체 {total}대 조회 중...',
    loadingProgress: '{loaded}/{total}대 조회 중...',
    allMachines: '전체 사출기',
    machineCount: '{n}대',
    allMolds: '전체 금형',
    countSuffix: '{n}건',
    total: '총 {n}건',
    filteredTotal: '{filtered}건 / 총 {total}건',
    empty: '데이터가 없습니다',
    pageInfo: '{start}-{end} / {total}',
  },
};

export default monitoring;
